var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { callAPI } from "@/react/lib/common";
export class ShoppingCartClient {
    getInitialShoppingCart() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            // @ts-expect-error legacy global injected by backend
            if ("reactData" in window && "shoppingCart" in window.reactData) {
                console.log("Found react data in window");
                // @ts-expect-error
                return Promise.resolve((_a = window.reactData) === null || _a === void 0 ? void 0 : _a.shoppingCart);
            }
            else {
                console.log("Global window variable not found");
            }
            return this.update();
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI("/api/webshop/cart");
                console.log("Got data from server", data);
                return data;
            }
            catch (error) {
                throw new Error(`Failed to update cart: ${error.message}`);
            }
        });
    }
    addItem(orderLine) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield callAPI(`/api/webshop/cart`, "POST", orderLine);
            }
            catch (error) {
                throw new Error(`Failed to add item: ${error.message}`);
            }
        });
    }
    addMultipleItems(orderLines) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield callAPI(`/api/webshop/cart`, "POST", orderLines);
            }
            catch (error) {
                throw new Error(`Failed to add items: ${error.message}`);
            }
        });
    }
    changeItemQuantity(uuid, quantity) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI(`/api/webshop/cart/${uuid}/quantity`, "PUT", {
                    quantity,
                });
                return data;
            }
            catch (error) {
                throw new Error(`Failed to update item: ${error.message}`);
            }
        });
    }
    updateItem(orderLine) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI(`/api/webshop/cart/${orderLine.uuid}`, "PUT", orderLine);
                return data;
            }
            catch (error) {
                throw new Error(`Failed to update item: ${error.message}`);
            }
        });
    }
    deleteItem(orderLine) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield callAPI(`/api/webshop/cart/${orderLine.uuid}`, "DELETE", orderLine);
                return data;
            }
            catch (error) {
                throw new Error(`Failed to delete item: ${error.message}`);
            }
        });
    }
}
